<div class="alert alert-danger" *ngIf="errorMessage">{{errorMessage}}</div>
<app-home-dashboard [loading]="loading" dashboardLabel="Flight school dashboard"
    [checkridesLoading]="checkridesLoading" [checkridesError]="checkridesError"
    [displayName]="flightSchool?.FlightSchoolIdDisplay" [checkrides]="homeCheckrides" paymentViewer="school"
    [tasks]="tasks" dashboardGroupKey="school-home-kpis" [kpiScopeFilters]="kpiScopeFilters" [tileDrillDownRoute]="tileDrillDownRoute"
    [expressionContext]="expressionContext" calendarRoute="/school-calendar" checkrideRoute="/school-checkrides"
    [showPlanOfActionActions]="showPlanOfActionActions" [examinerLabel]="examinerLabel" [showFlightSchool]="isOdaSchool" [isOdaSchool]="isOdaSchool">
</app-home-dashboard>
